import * as clerkLocalizations from '@clerk/localizations';
import type { LocalizationResource } from '@clerk/shared/types';
import type { SupportedLanguageCode } from './i18n';

// Clerk ships one resource per locale tag; Prospero UI languages map onto the
// closest available variant (no bn-BD bundle exists — bn-IN shares the script).
const CLERK_LOCALE_BY_LANGUAGE: Record<SupportedLanguageCode, LocalizationResource> = {
  it: clerkLocalizations.itIT,
  en: clerkLocalizations.enUS,
  es: clerkLocalizations.esES,
  ro: clerkLocalizations.roRO,
  uk: clerkLocalizations.ukUA,
  bn: clerkLocalizations.bnIN,
  zh: clerkLocalizations.zhCN,
  ar: clerkLocalizations.arSA,
};

export function resolveClerkLocalization(
  lng: string | undefined,
): LocalizationResource | undefined {
  const base = (lng ?? '').split('-')[0] as SupportedLanguageCode;
  return CLERK_LOCALE_BY_LANGUAGE[base];
}
